import { PayloadAction } from '@reduxjs/toolkit';
import { IUpload } from 'core/actions/admin/data';
import { signedUrlRequest } from 'core/services/admin';
import { CancelTokens, uploadRequest } from 'core/services/asset';
import { all, call, fork, put, select, takeLatest } from 'redux-saga/effects';
import { RootState } from 'types';
import { IUploadFile, uploadActions, UploadState } from 'core/slices/upload';

export function* uploadNext(action: PayloadAction<IUpload>) {
  const uploads: IUploadFile[] = yield select((state: RootState) => state.core.upload.uploads);
  const waiting = yield all(
    Object.values(uploads)
      .sort((a, b) => (a.created > b.created ? -1 : 1))
      .filter(up => up.state === UploadState.WAITING),
  );
  if (waiting.length) yield put(yield call(uploadRequest, waiting[0]));
}

function* cancelUpload(action: PayloadAction<string>) {
  if (CancelTokens[action.payload]) yield call([CancelTokens[action.payload], CancelTokens[action.payload].cancel]);
}

export function* watchUploadFulfilled() {
  yield takeLatest(uploadRequest.fulfilled, uploadNext);
}

export function* watchSignedUrls() {
  yield takeLatest(signedUrlRequest.fulfilled, uploadNext);
}

export function* watchCancelUpload() {
  //@ts-ignore
  yield takeLatest(uploadActions.cancelUpload, cancelUpload);
}

export function* uploadSaga() {
  yield all([fork(watchSignedUrls), fork(watchUploadFulfilled), fork(watchCancelUpload)]);
}
